module.exports = __webpack_public_path__ + "images/ExternalPromo/wix-footer-385.png?4be93";